import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-md" }
const _hoisted_2 = { class: "mb-md" }
const _hoisted_3 = ["innerHTML"]

import { OrderReceiptDeliverable } from '@/b2c/shared/api/server-apis';
import { computed } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftCard',
  props: {
    deliverable: null,
    index: null,
    total: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: OrderReceiptDeliverable;
    index: number;
    total: number;
}



const labels = useBlockLabels();

const itemCount = computed<number>(() => props.deliverable.items?.length ?? 0);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(labels).orderDeliverableGiftCardHeading), 1),
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).orderDeliverableHeader, { count: __props.index, total: __props.total })), 1),
    _createElementVNode("p", {
      innerHTML: _ctx.$dictionary.pluralize(_unref(itemCount), _unref(labels).orderDeliverableGiftCardDescription, _unref(labels).orderDeliverableGiftCardDescriptionPlural)
    }, null, 8, _hoisted_3)
  ]))
}
}

})